import { call, put, select, takeEvery } from 'redux-saga/effects'

import * as Actions from './actions'
import * as Selectors from './selectors'

import { UploadStatus, ResultStatus } from './constants'

const {
    PARSE_SPREADSHEET_DATA,
    UPLOAD_SPREADSHEET_DATA,
} = Actions

export const parseSpreadsheetDataSaga = Api => function* parseSpreadsheetDataSaga({ payload }) {
    yield put(Actions.setResultStatus(ResultStatus.NONE))
    yield put(Actions.setUploadStatus(UploadStatus.VALIDATING))

    yield put(Actions.clearValidationData())
    yield put(Actions.clearSpreadsheetData())

    const spreadsheet = yield call(Api.parseSpreadsheet, payload)
    const validation = yield call(Api.validateSpreadsheet, spreadsheet)

    yield put(Actions.setSpreadsheetData(spreadsheet))
    yield put(Actions.setValidationData(validation))

    yield put(Actions.setUploadStatus(UploadStatus.READY))
}

export const uploadSpreadsheetDataSaga = Api => function* uploadSpreadsheetDataSaga() {
    yield put(Actions.setUploadStatus(UploadStatus.UPLOADING))

    const spreadsheet = yield select(Selectors.getSpreadsheetData)
    const email = yield select(Selectors.getCurrentUserEmail)

    try {
        const result = yield call(Api.uploadSpreadsheet, spreadsheet, email)
        const totalRows = yield select(Selectors.getTotalRows)

        yield put(Actions.setResultStatus(ResultStatus.SUCCESS))
        yield put(Actions.setLastSuccessCount(totalRows))
    } catch (error) {
        yield put(Actions.setResultStatus(ResultStatus.ERROR))
        yield call(console.error, error)
    }

    yield put(Actions.clearValidationData())
    yield put(Actions.clearSpreadsheetData())

    yield put(Actions.setUploadStatus(UploadStatus.IDLE))
}

export default ({ Api }) => function* adminSagas() {
    yield takeEvery(PARSE_SPREADSHEET_DATA, parseSpreadsheetDataSaga(Api))
    yield takeEvery(UPLOAD_SPREADSHEET_DATA, uploadSpreadsheetDataSaga(Api))
}
